import React from "react";
import yahooImage from "../assets/yahoo.png";
import viantImage from "../assets/viant.png";
import { formatProviderCurrency, providerEvidenceRows } from "../utils/governedProviderEvidence";
import "./GovernedProviderEvidence.css";

const images = { yahoo_dsp: yahooImage, viant: viantImage };
const count = (value) => value === null ? "Unavailable" : value.toLocaleString("en-US");

// Adds reporting attribution beneath the existing advertiser KPI layout. It is
// informational; no account connectivity, eligibility or action is inferred.
export default function GovernedProviderEvidence({ payload }) {
  const rows = providerEvidenceRows(payload);
  if (!rows.length) return null;
  return <details className="governed-provider-evidence" open>
    <summary>Provider reporting evidence</summary>
    <div className="governed-provider-evidence-grid">
      {rows.map((row) => <article key={row.key} data-provider={row.key}>
        <div className="governed-provider-evidence-title"><img src={images[row.key]} alt="" aria-hidden="true" /><strong>{row.label}</strong></div>
        <dl>
          <div><dt>Client billed spend</dt><dd>{formatProviderCurrency(row.spend, row.currency)}</dd></div>
          <div><dt>Impressions</dt><dd>{count(row.impressions)}</dd></div>
          <div><dt>Clicks</dt><dd>{count(row.clicks)}</dd></div>
        </dl>
        <p>{row.source}{row.sourceReportedAt ? ` · ${row.sourceReportedAt}` : ""}</p>
        <p>Provider verification and optimization eligibility require separate governed evidence. Live optimization actions remain unavailable.</p>
      </article>)}
    </div>
  </details>;
}
